import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    height: "100%",
    maxHeight: "calc(100vh - 7.5rem)",
    padding: theme.spacing(2),
    overflow: "auto",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1),
    },
  },
  infoContainer: {
    width: "100%",
    marginTop: theme.spacing(1),
  },
  loadingWrapper: {
    padding: theme.spacing(2),
  },
  skeleton: {
    height: 40,
    marginBottom: theme.spacing(1),
  },
  resultsDivider: {
    margin: theme.spacing(0.5, 1),
  },
  tableContainer: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    justifyContent: "flex-end",
    [theme.breakpoints.down("sm")]: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
  },
  pagination: {
    marginTop: 10,
  },
  drawerPaper:{
    width:400,
    display:"flex",
    flexDirection:"column",
    height:"100%"
  },
  drawerContent:{
    width:400,
    height:"100%"
  }
}));
